// extracted by mini-css-extract-plugin
export var attribution = "_bh-4";
export var authorName = "_bh-5";
export var quote = "_bh-3";
export var testimonial = "_bh-2";
export var trustedBy = "_bh-0";
export var trustedByLabel = "_bh-1";